import { c as _c } from "react/compiler-runtime";
import { Button, Field, HStack, Input, NativeSelect, VStack } from '@chakra-ui/react';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { ComboboxItem } from '@src/components/sco/ComboboxTagInput';
import { CompanyIndustryComboboxInput } from '@src/components/sco/CompanyIndustryComboboxInput';
import { HelpModal } from '@src/components/sco/Requests/RequestBuilder/FormSections/HelpModal';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import company_stages from '@src/constants/company-stages';
import { UpsertGroupRequestInput } from '@src/graphql-types';
import React, { useEffect, useState } from 'react';
export const CompanyProfileSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(70);
  const groupRequest = props.groupRequest;
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [companyName, setCompanyName] = useState(groupRequest.requestingCompany.name || "");
  const [companyStageKey, setCompanyStageKey] = useState(groupRequest.requestingCompany.stageKey || "");
  const [companyElevatorPitch, setCompanyElevatorPitch] = useState(groupRequest.requestingCompany.elevatorPitch || "");
  const [companyWebsiteUrl, setCompanyWebsiteUrl] = useState(groupRequest.requestingCompany.url || "");
  const [companyIndustryKeys, setCompanyIndustryKeys] = useState();
  let t0;
  if ($[0] !== groupRequest.requestingCompany.elevatorPitch || $[1] !== groupRequest.requestingCompany.industryKeys || $[2] !== groupRequest.requestingCompany.name || $[3] !== groupRequest.requestingCompany.stageKey || $[4] !== groupRequest.requestingCompany.url) {
    t0 = () => {
      setCompanyName(groupRequest.requestingCompany.name);
      setCompanyStageKey(groupRequest.requestingCompany.stageKey);
      setCompanyElevatorPitch(groupRequest.requestingCompany.elevatorPitch);
      setCompanyWebsiteUrl(groupRequest.requestingCompany.url);
      setCompanyIndustryKeys(groupRequest.requestingCompany.industryKeys);
    };
    $[0] = groupRequest.requestingCompany.elevatorPitch;
    $[1] = groupRequest.requestingCompany.industryKeys;
    $[2] = groupRequest.requestingCompany.name;
    $[3] = groupRequest.requestingCompany.stageKey;
    $[4] = groupRequest.requestingCompany.url;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== groupRequest.requestingCompany.industryKeys) {
    t1 = groupRequest.requestingCompany.industryKeys?.toString();
    $[6] = groupRequest.requestingCompany.industryKeys;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== groupRequest.requestingCompany.elevatorPitch || $[9] !== groupRequest.requestingCompany.name || $[10] !== groupRequest.requestingCompany.stageKey || $[11] !== groupRequest.requestingCompany.url || $[12] !== t1) {
    t2 = [groupRequest.requestingCompany.name, groupRequest.requestingCompany.stageKey, groupRequest.requestingCompany.elevatorPitch, groupRequest.requestingCompany.url, groupRequest.requestingCompany.stageKey, t1];
    $[8] = groupRequest.requestingCompany.elevatorPitch;
    $[9] = groupRequest.requestingCompany.name;
    $[10] = groupRequest.requestingCompany.stageKey;
    $[11] = groupRequest.requestingCompany.url;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  useEffect(t0, t2);
  let t3;
  if ($[14] !== companyElevatorPitch || $[15] !== companyIndustryKeys || $[16] !== companyName || $[17] !== companyStageKey || $[18] !== companyWebsiteUrl || $[19] !== props) {
    t3 = async t4 => {
      const next = t4 === undefined ? _temp : t4;
      if (!props.groupRequest.groupRequestId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            upsertCompanyInput: {
              name: companyName,
              elevatorPitch: companyElevatorPitch,
              url: companyWebsiteUrl,
              industryKeys: companyIndustryKeys,
              stageKey: companyStageKey
            }
          } as UpsertGroupRequestInput
        }
      });
      if (next) {
        next();
      }
    };
    $[14] = companyElevatorPitch;
    $[15] = companyIndustryKeys;
    $[16] = companyName;
    $[17] = companyStageKey;
    $[18] = companyWebsiteUrl;
    $[19] = props;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const performSave = t3;
  let t4;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Field.Label>Company Name</Field.Label>;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== performSave) {
    t5 = ev => performSave();
    $[22] = performSave;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setCompanyName(e.target.value);
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== companyName || $[26] !== t5) {
    t7 = <Field.Root>{t4}<Input placeholder="Acme Inc." size="sm" value={companyName} onBlur={t5} onChange={t6} /></Field.Root>;
    $[25] = companyName;
    $[26] = t5;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Field.Label>Elevator Pitch</Field.Label>;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== performSave) {
    t9 = ev_0 => performSave();
    $[29] = performSave;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e_0 => setCompanyElevatorPitch(e_0.target.value);
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== companyElevatorPitch || $[33] !== t9) {
    t11 = <Field.Root>{t8}<AutoResizeTextarea fontSize="sm" maxHeight="200px" placeholder="Brief explanation of what you do." size="sm" value={companyElevatorPitch} onBlur={t9} onChange={t10} /></Field.Root>;
    $[32] = companyElevatorPitch;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Field.Label>Stage</Field.Label>;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  let t14;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_1 => setCompanyStageKey(e_1.target.value);
    t14 = company_stages.map(_temp2);
    $[36] = t13;
    $[37] = t14;
  } else {
    t13 = $[36];
    t14 = $[37];
  }
  let t15;
  if ($[38] !== companyStageKey) {
    t15 = <NativeSelect.Field placeholder="Select One" size="sm" value={companyStageKey} onChange={t13}>{t14}</NativeSelect.Field>;
    $[38] = companyStageKey;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <NativeSelect.Indicator />;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t15) {
    t17 = <Field.Root>{t12}<NativeSelect.Root>{t15}{t16}</NativeSelect.Root></Field.Root>;
    $[41] = t15;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Field.Label>Website URL</Field.Label>;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== performSave) {
    t19 = ev_1 => performSave();
    $[44] = performSave;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = e_2 => setCompanyWebsiteUrl(e_2.target.value);
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== companyWebsiteUrl || $[48] !== t19) {
    t21 = <Field.Root>{t18}<Input placeholder="https://www.acme.com" size="sm" value={companyWebsiteUrl} onBlur={t19} onChange={t20} /></Field.Root>;
    $[47] = companyWebsiteUrl;
    $[48] = t19;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Field.Label>Industries</Field.Label>;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const t23 = groupRequest.requestingCompany.industries as ComboboxItem[];
  let t24;
  let t25;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      inputProps: {
        size: "sm"
      },
      popoverProps: {
        placement: "top"
      },
      allowMultipleSelections: true
    };
    t25 = industryItems => setCompanyIndustryKeys(industryItems.map(_temp3));
    $[51] = t24;
    $[52] = t25;
  } else {
    t24 = $[51];
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t23) {
    t26 = <Field.Root>{t22}<CompanyIndustryComboboxInput defaultValue={t23} comboboxTagInputProps={t24} onChange={t25} /></Field.Root>;
    $[53] = t23;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== performSave || $[56] !== props) {
    t27 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async e_3 => {
        await performSave(() => props.onNextSection ? props.onNextSection() : null);
      }}>{"Save & Continue"}</Button></HStack>;
    $[55] = performSave;
    $[56] = props;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t11 || $[59] !== t17 || $[60] !== t21 || $[61] !== t26 || $[62] !== t27 || $[63] !== t7) {
    t28 = <VStack align="stretch" gap={4} padding={4}>{t7}{t11}{t17}{t21}{t26}{t27}</VStack>;
    $[58] = t11;
    $[59] = t17;
    $[60] = t21;
    $[61] = t26;
    $[62] = t27;
    $[63] = t7;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== showHelpModal) {
    t29 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[65] = showHelpModal;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t28 || $[68] !== t29) {
    t30 = <>{t28}{t29}</>;
    $[67] = t28;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  return t30;
};
function _temp() {}
function _temp2(stage, idx) {
  return <option key={idx} value={stage.key}>{`${stage.name}: ${stage.description}`}</option>;
}
function _temp3(i) {
  return i.key;
}